var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccContractors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7859",
    "data-name": "Rectangle 7859",
    width: 28,
    height: 28,
    transform: "translate(580 1039)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7858",
    "data-name": "Rectangle 7858",
    width: 22.836,
    height: 22.478,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contractors",
    transform: "translate(-580 -1039)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32385",
    "data-name": "Group 32385",
    transform: "translate(582.582 1041.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32384",
    "data-name": "Group 32384",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34578",
    "data-name": "Path 34578",
    d: "M22.842,19.227l-3.251,3.251-6.816-6.807L11.253,14.14h-.01L8.2,11.085h-.01l-.619-.619L6.135,9.022a4.585,4.585,0,0,1-5.5-5.982L3.572,5.968l2.76-2.76L3.4.281a4.577,4.577,0,0,1,5.982,5.49Z",
    transform: "translate(-0.006 0)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7857",
    "data-name": "Rectangle 7857",
    width: 9.8,
    height: 4.32,
    transform: "translate(0.003 19.269) rotate(-45)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34579",
    "data-name": "Path 34579",
    d: "M8.34,11.286l3.045,3.055L8.33,11.286Z",
    transform: "translate(-0.148 -0.201)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34580",
    "data-name": "Path 34580",
    d: "M14.7,11.02v.01L11.65,7.976Z",
    transform: "translate(-0.207 -0.142)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34581",
    "data-name": "Path 34581",
    d: "M22.418,2.208l-1.748,4.9-2.18.01-2.5,2.514L12.93,6.579l2.514-2.514V1.894l4.9-1.758,1.031,1.041h.01Z",
    transform: "translate(-0.23 -0.002)",
    fill: "#b3b6c6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccContractors);
export default __webpack_public_path__ + "static/media/mcc_contractors.34bd4f4f94bbd273724dfd84d8e0b1c4.svg";
export { ForwardRef as ReactComponent };